import axiosInstance from "./AxiosConfig";

class BusinessTypeApiService {
  async CreateBusinessType(businessName) {
    
    try {
      const response = await axiosInstance.post("/businessType/create", {
        businessName,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAllBusinessType() {
    
    try {
      const response = await axiosInstance.get("/businessType/get");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateBusinessType(id, businessName) {
    
    try {
      const response = await axiosInstance.put(`/businessType/update/${id}`, {
        businessName,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteBusinessType(id) {
    
    try {
      const response = await axiosInstance.delete(`/businessType/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new BusinessTypeApiService();
